/* eslint-disable */

// component
import Table from 'components/Table/index';
import H5 from 'components/H5';
import LoadingBox from 'components/LoadingBox.js';
import Badge from "components/Badge";
import NoData from './NoData';
import './style.css'

// library
import React from 'react';
import moment from 'moment';
import _ from 'lodash';
import styled from 'styled-components';

const Div = styled.div`
  @media only screen and (max-width: 1024px) {
    display: none !important;
  }
`;

const SetLoadingBox = (count,valueChannel) => {
  let i;
  const data = [];
  for (i = 0; i < count; i += 1) {
    data.push(
      <tr>
        <td>
          <LoadingBox height={10} borderRadius={8} />
        </td>
        <td>
          <LoadingBox height={10} borderRadius={8} />
        </td>
        <td>
          <LoadingBox height={10} borderRadius={8} />
        </td>
        <td className={`${valueChannel === 'sms' ? '' : 'd-none'}`}>
          <LoadingBox height={10} borderRadius={8} />
        </td>
        <td className={`${valueChannel === 'sms' || valueChannel === 'sms_otp' ? '' : 'd-none'}`}>
          <LoadingBox height={10} borderRadius={8} />
        </td>
        <td>
          <LoadingBox height={10} borderRadius={8} />
        </td>
      </tr>
    );
  }
  return data;
};

const TableData = (props) => {
  const { data, loading, valueChannel } = props;
  console.log('country code', data)
  const isNoData = data.length <= 0 && !loading;

  function lastUpdate() {
    let result;
    if (data && data.length) {
      const sortedData = _.sortBy(data, ['updated_at']);
      const lastUpdatedDate =
        sortedData[0]?.updated_at !== null ? sortedData[0].updated_at : sortedData[0].created_at;
      result = moment(lastUpdatedDate).fromNow();
    } else {
      result = 'No data';
    }
    return result;
  }

  return (
    <Div className="d-flex flex-column position-relative">
      <Table className={`${isNoData && `margin-bottom-40`}`}>
        <thead>
          <tr>
            <th className="col-sm-1 text-center">Message ID</th>
            <th className="col-sm-1 text-center">{valueChannel === 'email' ? 'EMAIL' : 'NUMBER'}</th>
            <th className="col-sm-1 text-center">DATE</th>
            <th className={`${valueChannel !== 'sms' && 'd-none' } col-sm-1 text-center`}>TOTAL SMS</th>
            <th className={`${valueChannel === 'sms' || valueChannel === 'sms_otp' ? '' : 'd-none' } col-sm-1 text-center`}>COUNTRY CODE</th>
            <th className="col-sm-1 text-center">STATUS</th>
          </tr>
        </thead>
        <tbody>
          {!isNoData && (
            <>
              {loading && SetLoadingBox(10,valueChannel)}
              {data.map((val) => {
                return (
                  <tr key={val.uuid}>
                    <td className="text-center">
                      {val.uuid ? val.uuid : val.msgid}
                    </td>
                    <td className="text-center">
                      {valueChannel === 'whatsapp' && val.phone_number}
                      {valueChannel === 'sms' && val.phone_number}
                      {valueChannel === 'sms_otp' && val.phone_number}
                      {valueChannel === 'email' && val.email}
                      {valueChannel === 'call' && val.phone_number}
                      {valueChannel === 'call_otp' && val.to_number}
                    </td>
                    <td className="text-center">{moment(val.created_at).format('DD-MM-YYYY hh:mm A')}</td>
                    <td className={`${valueChannel !== 'sms' ? 'd-none' : 'text-center' }`}>{val.total_sms}</td>
                    <td className={`${valueChannel === 'sms' || valueChannel === 'sms_otp' ? '' : 'd-none' } text-center`}>{val.country ? val.country : '-'}</td>
                    <td className={`${val.status === "in_queue" ? '' : ''} text-center tooltipViewerMode`}>
                      {val.status === 'read' && (
                        <Badge
                          // title={val.status}
                          textColor='#219653'
                          backgroundColor='#F0FFF6'
                          fontSize='12px'
                          style={{ width: '120px' }}
                        >
                          {val.status}
                          <div className={`${val?.additional_info?.reason ? 'tooltipTextViewerMode' : 'd-none'}`}>
                            <span className="tooltiptext">{val?.additional_info?.reason ? val?.additional_info?.reason : '~'}</span>
                          </div>
                        </Badge>
                      )}
                      {val.status === 'rejected' && (
                        <Badge
                          // title={val.status}
                          textColor='#FF8B00'
                          backgroundColor='#FFFAE6'
                          fontSize='12px'
                          style={{ width: '120px' }}
                        >
                          {val.status}
                          <div className={`${val?.additional_info?.reason ? 'tooltipTextViewerMode' : 'd-none'}`}>
                            <span className="tooltiptext">{val?.additional_info?.reason ? val?.additional_info?.reason : '~'}</span>
                          </div>
                        </Badge>
                      )}
                      {val.status === 'undelivered' && (
                        <Badge
                          // title={val.status}
                          textColor='#FF8B00'
                          backgroundColor='#FFFAE6'
                          fontSize='12px'
                          style={{ width: '120px' }}
                        >
                          {val.status}
                          <div className={`${val?.additional_info?.reason ? 'tooltipTextViewerMode' : 'd-none'}`}>
                            <span className="tooltiptext">{val?.additional_info?.reason ? val?.additional_info?.reason : '~'}</span>
                          </div>
                        </Badge>
                      )}
                      {val.status === 'failed' && (
                        <Badge
                          // title={val.status}
                          textColor='#EB5757'
                          backgroundColor='#FFE9F0'
                          fontSize='12px'
                          style={{ width: '120px' }}
                        >
                          {val.status}
                          <div className={`${val?.error_reason?.reason ? 'tooltipTextViewerMode' : 'd-none'}`}>
                            <span className="tooltiptext">{val?.error_reason?.reason ? val?.error_reason?.reason : '~'}</span>
                          </div>
                        </Badge>
                      )}
                      {val.status === 'delivered' && (
                        <Badge
                          // title={val.status}
                          textColor='#219653'
                          backgroundColor='#F0FFF6'
                          style={{ width: '120px' }}
                        >
                          {val.status}
                          <div className={`${val?.additional_info?.reason ? 'tooltipTextViewerMode' : 'd-none'}`}>
                            <span className="tooltiptext">{val?.additional_info?.reason ? val?.additional_info?.reason : '~'}</span>
                          </div>
                        </Badge>
                      )}
                      {val.status === 'sent' && (
                        <Badge
                          // title={val.status}
                          textColor='#219653'
                          backgroundColor='#F0FFF6'
                          fontSize='12px'
                          style={{ width: '120px' }}
                        >
                          {val.status}
                          <div className={`${val?.additional_info?.reason ? 'tooltipTextViewerMode' : 'd-none'}`}>
                            <span className="tooltiptext">{val?.additional_info?.reason ? val?.additional_info?.reason : '~'}</span>
                          </div>
                        </Badge>
                      )}
                      {val.status === 'processed' && (
                        <Badge
                          // title={val.status}
                          textColor='#2F80ED'
                          backgroundColor='#EAF3FF'
                          fontSize='12px'
                          style={{ width: '120px' }}
                        >
                          {val.status}
                          <div className={`${val?.additional_info?.reason ? 'tooltipTextViewerMode' : 'd-none'}`}>
                            <span className="tooltiptext">{val?.additional_info?.reason ? val?.additional_info?.reason : '~'}</span>
                          </div>
                        </Badge>
                      )}
                      {val.status === 'in_queue' && (
                        <Badge
                          // title={val.status}
                          textColor='#FF8B00'
                          backgroundColor='#FFFAE6;'
                          fontSize='12px'
                          style={{ width: '120px' }}
                        >
                          {val.status}
                          <div className={`${val?.additional_info?.reason ? 'tooltipTextViewerMode' : 'd-none'}`}>
                            <span className="tooltiptext">{val?.additional_info?.reason ? val?.additional_info?.reason : '~'}</span>
                          </div>
                        </Badge>
                      )}
                      {val.status === 'submitted' && (
                        <Badge
                          // title={val.status}
                          textColor='#FF8B00'
                          backgroundColor='#FFFAE6;'
                          fontSize='12px'
                          style={{ width: '120px' }}
                        >
                          {val.status}
                          <div className={`${val?.additional_info?.reason ? 'tooltipTextViewerMode' : 'd-none'}`}>
                            <span className="tooltiptext">{val?.additional_info?.reason ? val?.additional_info?.reason : '~'}</span>
                          </div>
                        </Badge>
                      )}
                      {val.status === 'in_call' && (
                        <Badge
                          // title={val.status}
                          textColor='#219653'
                          backgroundColor='#F0FFF6'
                          fontSize='12px'
                          style={{ width: '120px' }}
                        >
                          {val.status}
                          <div className={`${val?.additional_info?.reason ? 'tooltipTextViewerMode' : 'd-none'}`}>
                            <span className="tooltiptext">{val?.additional_info?.reason ? val?.additional_info?.reason : '~'}</span>
                          </div>
                        </Badge>
                      )}
                      {val.status === 'rna' && (
                        <Badge
                          // title={val.status}
                          textColor='#219653'
                          backgroundColor='#F0FFF6'
                          fontSize='12px'
                          style={{ width: '120px' }}
                        >
                          {val.status}
                          <div className={`${val?.additional_info?.reason ? 'tooltipTextViewerMode' : 'd-none'}`}>
                            <span className="tooltiptext">{val?.additional_info?.reason ? val?.additional_info?.reason : '~'}</span>
                          </div>
                        </Badge>
                      )}
                      {val.status === 'answered' && (
                        <Badge
                          // title={val.status}
                          textColor='#219653'
                          backgroundColor='#F0FFF6'
                          fontSize='12px'
                          style={{ width: '120px' }}
                        >
                          {val.status}
                          <div className={`${val?.additional_info?.reason ? 'tooltipTextViewerMode' : 'd-none'}`}>
                            <span className="tooltiptext">{val?.additional_info?.reason ? val?.additional_info?.reason : '~'}</span>
                          </div>
                        </Badge>
                      )}
                      {val.status === 'user_busy' && (
                        <Badge
                          // title={val.status}
                          textColor='#FF8B00'
                          backgroundColor='#FFFAE6'
                          fontSize='12px'
                          style={{ width: '120px' }}
                        >
                          {val.status}
                          <div className={`${val?.additional_info?.reason ? 'tooltipTextViewerMode' : 'd-none'}`}>
                            <span className="tooltiptext">{val?.additional_info?.reason ? val?.additional_info?.reason : '~'}</span>
                          </div>
                        </Badge>
                      )}
                      {val.status === 'opened' && (
                        <Badge
                          // title={val.status}
                          textColor='#219653'
                          backgroundColor='#F0FFF6'
                          fontSize='12px'
                          style={{ width: '120px' }}
                        >
                          {val.status}
                          <div className={`${val?.additional_info?.reason ? 'tooltipTextViewerMode' : 'd-none'}`}>
                            <span className="tooltiptext">{val?.additional_info?.reason ? val?.additional_info?.reason : '~'}</span>
                          </div>
                        </Badge>
                      )}
                      {val.status === 'clicked' && (
                        <Badge
                          // title={val.status}
                          textColor='#219653'
                          backgroundColor='#F0FFF6'
                          fontSize='12px'
                          style={{ width: '120px' }}
                        >
                          {val.status}
                          <div className={`${val?.additional_info?.reason ? 'tooltipTextViewerMode' : 'd-none'}`}>
                            <span className="tooltiptext">{val?.additional_info?.reason ? val?.additional_info?.reason : '~'}</span>
                          </div>
                        </Badge>
                      )}
                      {val.status === 'unsubscribe' && (
                        <Badge
                          // title={val.status}
                          textColor='#FF8B00'
                          backgroundColor='#FFFAE6'
                          fontSize='12px'
                          style={{ width: '120px' }}
                        >
                          {val.status}
                          <div className={`${val?.additional_info?.reason ? 'tooltipTextViewerMode' : 'd-none'}`}>
                            <span className="tooltiptext">{val?.additional_info?.reason ? val?.additional_info?.reason : '~'}</span>
                          </div>
                        </Badge>
                      )}
                      {val.status === 'success' && (
                        <Badge
                          // title={val.status}
                          textColor='#219653'
                          backgroundColor='#F0FFF6'
                          fontSize='12px'
                          style={{ width: '120px' }}
                        >
                          {val.status}
                          <div className={`${val?.additional_info?.reason ? 'tooltipTextViewerMode' : 'd-none'}`}>
                            <span className="tooltiptext">{val?.additional_info?.reason ? val?.additional_info?.reason : '~'}</span>
                          </div>
                        </Badge>
                      )}
                    </td>
                  </tr>
                );
              })}
            </>
          )}
        </tbody>
      </Table>
      {isNoData ? (
        <NoData />
      ) : (
        <H5 className="margin-top-20">{`Last transaction update: ${lastUpdate()}`}</H5>
      )}
    </Div>
  );
};

export default TableData;
